<div class="doughnut-outer-container" id="doughnut-outer-container" [style.width.px]="containerWidth">
  <canvas #chartCanvas [id]="'base-doughnut-chart-' + unique_id" [width]="170"> </canvas>
  <div *ngIf="label" class="doughnut-label" id="doughnut-label">
    {{ label }}
  </div>
  <div
    *ngIf="description"
    class="doughnut-description"
    id="doughnut-description"
  >
    {{ description }}
  </div>
  <div
    *ngIf="secondaryDescription"
    class="doughnut-secondary-description"
    id="doughnut-secondary-description"
  >
    {{ secondaryDescription }}
  </div>
</div>
